<app-tool-settings-bar
  *ngIf="!tableData.hideTableBar"
  [filters]="tableFilters"
  [moreFilters]="moreFilters"
  [toolSettingsData]="tableData"
  [defaultOrder]="defaultSortOrder"
  [source]="source"
  (search)="performSearch($event)"
  (create)="performCreate($event)"
  (filter)="performFilter($event)"
  (clearSearchFilterParams)="performFilterAndSearch($event)"
  (transfer)="handleAction({ action: 'transfer', source: 'tools' })"
  (inventory)="handleAction({ action: 'inventory', source: 'inventories' })"
  (inventoryTransfer)="handleAction({ action: 'inventoryTransfer', source: 'inventories' })"
  (exportTools)="performToolBatchExport($event)"
  (exportToolModels)="performToolModelBatchExport($event)"
  (exportTransfers)="performTransfersBatchExport($event)"
  (exportInventories)="performInventoryBatchExport($event)"
  (clearFilters)="onClearFilters()">
</app-tool-settings-bar>
<app-tool-settings-table
  #toolSettingsTable
  [headers]="tableData"
  [rows]="tableData.data"
  [totalItems]="tableData.pagination?.totalCount"
  [meta]="tableData.meta"
  [source]="source"
  [sortData]="searchParams.order"
  [(selected)]="selectedItems"
  (action)="handleAction($event)"
  (selectedChange)="handleSelectedChange($event)"
  (selectedAdd)="handleSelectedAdd($event)"
  (selectedRemove)="handleSelectedRemove($event)"
  (selectedAll)="handleSelectAll($event)"
  (refreshSelectAll)="refreshDataForSelectAll($event)"
  (removeAll)="handleRemoveAll($event)"></app-tool-settings-table>
<app-tool-settings-paging
 [customClass]="'tool-settings-paging--custom'"
  *ngIf="!tableData.hideTablePaging"
  [links]="tableData.pagination"
  (navigation)="performPaging($event)"></app-tool-settings-paging>

<!-- model dialog prompt -->
<app-dialog id="delete-dialog">
  <div class="dialog-header d-flex justify-content-between">
    <h5 class="modal-title">{{ dialogRecord.actionName }} {{ dialogRecord?.data?.toolId }}</h5>
  </div>
  <span class="dialog-body">
    <span *ngIf="dialogRecord.actionType === 'delete'">
      Are you sure you want to {{ dialogRecord.actionName | lowercase }} <b>{{ dialogRecord?.name }}</b
      >?
    </span>
  </span>
  <span class="dialog-footer">
    <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal">Cancel</button>
    <button type="button" class="btn btn-primary" id="delete-dialog_btn-ok">Continue</button>
  </span>
</app-dialog>
